<template>
    <div>
        <div class="listing__nav">
            <div class="uploadProduct">
                <div id="csvdata" class="container allinline">
                    <upload-category-csv type="category" class="cstm" :category="this.category"></upload-category-csv>
                    <div class="pull-right">
                        <add-new-category :category="category"></add-new-category>
                    </div>
                </div>
                <category @clicked-show-detail="clickedShowDetailModal"></category>
            </div>
        </div>
    </div>
</template>

<script>

    import uploadCategoryCsv from './CategoryCsvUpload'
    import addNewCategory from './addNewCategory'

    export default {
        components: {
            'upload-category-csv': uploadCategoryCsv,
            'add-new-category': addNewCategory
        },

        data: function () {
            return {
                category: null,
            }
        },

        methods: {
            clickedShowDetailModal(value) {
                console.log("parent value");
                console.log(value);
                this.category = value;
            },

        },
        mounted: function () {
        },
        watch: {},
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },

        }
    }

</script>
